<i18n>
  {
    "fr": {
      "info": {
        "1": "Les prix affichés comprennent les taxes aéroport et frais de dossier.",
        "2": "Les disponibilités sont affichées en temps réel et peuvent évoluer d'une minute à l'autre."
      }
    },
    "en": {
      "info": {
        "1": "The prices shown include airport taxes and booking fees.",
        "2": "Availabilities are displayed in real time and can change from one minute to the next."
      }
    }
  }
</i18n>

<template>
  <div>
    <v-card
      class="mx-auto my-8"
      height="400px"
      flat
    >
      <div id="search-results-loader-animation">
        <v-img
          class="mx-auto"
          width="190px"
          src="@/assets/img/airport.svg"
        />
        <div class="lds-ellipsis mx-auto">
          <div /><div /><div /><div />
        </div>
        <div class="text-center">
          <p>{{ $t('info.1') }}</p>
          <p>{{ $t('info.2') }}</p>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FlightSearchResultsLoader'
}
</script>

<style scoped>
  #search-results-loader-animation {
    position: relative;
    top: 30px;
  }

  .lds-ellipsis {
    display: inline-block;
    position: relative;
    left: calc(50% - 40px);
    width: 80px;
    height: 80px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #0089ba;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
</style>
